import BufferOp from 'jsts/org/locationtech/jts/operation/buffer/BufferOp';
import UnionOp from 'jsts/org/locationtech/jts/operation/union/UnionOp';
import IsValidOp from 'jsts/org/locationtech/jts/operation/valid/IsValidOp';
import { reader, writer } from './io';

/**
 * Performs a cascaded union operation on a collection of features.
 * @param {Object} featureCollection - A GeoJSON FeatureCollection object.
 * @returns {Object|null} A GeoJSON Feature object representing the union of the input features, or null if the input is empty.
 */
export default function cascadedUnion(featureCollection) {
  // Function to clean a geometry by buffering it by 0
  const cleanGeom = (g) => BufferOp.bufferOp(g, 0);

  let union;
  featureCollection.features
    .map((feature) => reader.read(feature).geometry)
    .forEach((polygon, polygonIdx) => {
      // If the polygon is not valid, clean it
      if (!IsValidOp.isValid(polygon)) {
        polygon = cleanGeom(polygon);
      }
      // If this is the first polygon, initialize the union
      // Otherwise, union the current polygon with the existing union
      union = polygonIdx === 0 ? polygon : UnionOp.union(union, polygon);
    });

  // If a union was created, return it as a GeoJSON Feature
  // Otherwise, return null
  return union
    ? {
        type: 'Feature',
        geometry: writer.write(union),
        properties: { area: union.getArea() },
      }
    : null;
}
